import { useCallback } from "react";
import { useV2HeaderNames } from "./useV2HeaderNames";
import {
  chipDisplayLabel,
  FilterChipDef,
} from "../components/FilterBar/filterChipDefs";

/**
 * Returns a stable function that resolves a chip's display label,
 * respecting customer column-name overrides via useV2HeaderNames.
 */
export function useFilterDisplayLabel(customerId: string | undefined) {
  const { getLabel } = useV2HeaderNames(customerId);
  return useCallback(
    (chipDef: FilterChipDef) => chipDisplayLabel(chipDef, getLabel),
    [getLabel],
  );
}
